import { render, staticRenderFns } from "./VonInputText.vue?vue&type=template&id=4faedda6&"
import script from "./VonInputText.vue?vue&type=script&lang=js&"
export * from "./VonInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports